import {config} from "./config";
import {request} from "./request";

function createLijin(data, cb, fail_cb) {
    request.post.call(this, config.apiList.jdlijins, data, {}, cb, fail_cb)
}

function getLijins(data, cb, fail_cb) {
    request.get.call(this, config.apiList.jdlijins, data, cb, fail_cb)
}

var jdApi = {
    createLijin: createLijin,
    getLijins: getLijins
}

export {jdApi}